/**
 * @description This is for the global directory. 
 */
import axios from "axios";
let users = []
let actions = {
    /**
     * @returns {Promise<Array>}
     */
    getAllUsers() {
        return new Promise((resolve, reject) => {
            axios.get("/admin/user")
                .then(data => {
                    let users = data.data.object;
                    resolve(users);
                })
                .catch(err => {
                    reject(err);
                })
        })
    },
    /**
     * 
     * @param {String} name Name of the user
     * @param {String} phone Phone number (will be reformatted by twilio)
     * @returns {Promise<Object>} Returns new user doc.
     */
    addUser(name, phone) {
        return new Promise((resolve, reject) => {
            axios.post("/admin/user", { name: name, phone: phone })
                .then(data => {
                    let user = data.data.object;
                    resolve(user)
                })
                .catch(err => { reject(err) })
        })
    },
    removeUser(id) {
        return new Promise((resolve, reject) => {
            axios.delete("/admin/user", { data: { _id: id } })
                .then(data => {
                    // let user = data.data.object;
                    resolve()
                })
                .catch(err => { reject(err) })

        })
    },
    getUser(id) {
        return new Promise((resolve, reject) => {

        })
    },
    editUser(id, name, phone) {
        return new Promise((resolve, reject) => {
            axios.put("/admin/user",{_id:id,name:name,phone:phone})
            .then(data=>{
                let user = data.data.object;
                resolve(user);
            })
            .catch(err=>{
                reject(err);
            })
        })
    }
}
export default actions;